import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
	name: "auth",
	initialState: {
		email: "",
		typeAdmin: "",
		enterpiseid: "",
		imgUrl: "",
		nameEnterprise: "",
		name: "",
	},
	reducers: {
		setLoginUser: (state, { payload }) => {
			localStorage.setItem("x-token", payload.token);
			state.email = payload.email;
		},
		setAdminType: (state, { payload }) => {
			state.typeAdmin = payload;
		},
		setAdminEnterpiseid: (state, { payload }) => {
			state.enterpiseid = payload;
		},
		setAdminName: (state, { payload }) => {
			state.name = payload;
		},
		setAdminEmail: (state, { payload }) => {
			state.email = payload;
		},
		setImgUrlEnterpise: (state, { payload }) => {
			state.imgUrl = payload;
		},
		setNameEnterprise: (state, { payload }) => {
			state.nameEnterprise = payload;
		},
	},
});

export const { setImgUrlEnterpise, setNameEnterprise, setLoginUser, setAdminType, setAdminEnterpiseid, setAdminName, setAdminEmail } =
	authSlice.actions;
